import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ContextData } from '../../../../context/Context';
import {
  Typography
} from "@mui/material";
import baseUrl from "../../../../BaseURL";
import { toast } from "react-toastify";
import './CardStudio.css';
import PreCardShow from './PreCardShow';



const IDCardShow = (props) => {


  const [profileData, setProfileData] = useState(null);
  const {accesstoken,Refresh,setRefresh} = React.useContext(ContextData)
  const [error, setError] = useState(null);


  const HandleApprove = async (token) =>{


    try {
      const response = await axios.put(`${baseUrl}/auth/Verified`,{token},{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }}).then(res=>{
               toast.success(res.data)
               setRefresh(!Refresh)
        })

       } catch (err) {
       if(err) console.log(err.message)
     //  setLoader(false)
       }

  }


  useEffect(() => {

    const fetchProfileData = async () => {
      setProfileData("get")
      try {
        const response = await axios.get(`${baseUrl}/auth/get_member_data_pageID_card/${props.token}`, {
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            'authorization': `Bearer ${accesstoken !== null && accesstoken}`
          }
        });
        setProfileData(response.data[0]);
      } catch (error) {
        setError("Error fetching profile data");
      }
    };

    fetchProfileData();



  },[props.token,Refresh]);

  if (!props.token) return <div className="fin-card-empty"><span aria-hidden="true">▤</span><h3>Select a member to begin</h3><p>Choose a name from the member list to review their details and prepare an identity card.</p></div>;

  if (error) {
    return <Typography variant="h6">{error}</Typography>;
  }

  if (!profileData) {
      if(props.vr === "vr"){
        return <Typography variant="h6">Click name to load the profile</Typography>;
      }else{
        return <Typography variant="h6">Select a member</Typography>;
      }

  }

  return (
    <>
     {
      profileData === "get" ?  <div> <p>Loading new data</p> </div> :
      <>

<PreCardShow
profileData = {profileData}
/>
      </>
     }

    </>
  );
};

export default IDCardShow;


// get_data_adminuser